export async function marketApi(path, body, method) {
  const response = await fetch(`/api/market${path}`, {
    credentials: 'include', method: method || (body ? 'POST' : 'GET'),
    headers: { 'Content-Type': 'application/json', 'X-Store-Request': '1' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || '요청을 처리하지 못했습니다. 다시 시도해 주세요.');
  return data;
}
export function requestKey() {
  return window.crypto.randomUUID();
}
let sdkPromise;
export async function payOrder(order, config, customerKey) {
  if (!config?.enabled) throw new Error(config?.message || '유료 결제 준비 중입니다.');
  if (!window.TossPayments) {
    if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://js.tosspayments.com/v2/standard';
      script.onload = resolve;
      script.onerror = () => { sdkPromise = null; script.remove(); reject(new Error('결제창을 불러오지 못했습니다. 다시 시도해 주세요.')); };
      document.head.appendChild(script);
    });
    await sdkPromise;
  }
  return window.TossPayments(config.clientKey).payment({ customerKey }).requestPayment({
    method: 'CARD', amount: { currency: 'KRW', value: Number(order.amount) },
    orderId: order.id, orderName: String(order.product_name).slice(0,100),
    successUrl: `${window.location.origin}/Market/payment`,
    failUrl: `${window.location.origin}/Market/payment`,
  });
}
export const statusLabel = { awaiting_payment: '결제 대기', requested: '접수 대기', accepted: '진행 중', delivered: '결과 전달', completed: '완료', cancelled: '취소', refund_requested: '환불 요청', refunded: '환불 완료' };
export const kindLabel = { donation: '재능기부', service: '전문 서비스', course: '강의' };
